<template>
  <main class="app-layout" id="main_content_easychat"
    :class="{ 'this_private_layout': conversations[selected] && conversations[selected].private, 'loading': is_loading, 'hide_users': !show_users, 'systemChat': defaultSelectedUser, 'basicMode': basicMode }">

    <ProgressSpinner v-if="is_loading" />
    <DockMenu :dockMenuValue="dockMenuValue" v-if="!is_loading && ((isMobile && dockMenuValue !== 'chat' && !basicMode) || (!isMobile && !basicMode))"
      @send-events="onEvents" :isMobile="isMobile" :my_profile="my_profile" />

    <div id="middle_Easy">
      <ToolBar :selected="conversations[selected]" :dockMenuValue="dockMenuValue" v-if="!is_loading"
        :my_profile="my_profile" @send-events="onEvents" :userCount="conversations[selected].users.length"
        :isMobile="isMobile" :notifications="notifications" @update-theme="updateTheme" :basicMode="basicMode" />
      <LeftBarArea :conversations="conversations" :my_profile="my_profile" :selected="selected"
        :selected_id="selected_id" @update-selected="updateSelected" @send-events="onEvents"
        v-if="(!is_loading && dockMenuValue == 'chat') && !isMobile && !defaultSelectedUser"
        :create_channel="g_settings.create_channel" :popular_users="popular_users" :basicMode="basicMode" />
      <MainContent :conversations="conversations" :my_profile="my_profile" :selected="selected" :bg_image="bg_image"
        :blocks="blockedUsers" :follows="followList" :show_users="show_users" @typing="onTyping" :settings="settings"
        :isGuestLogin="isGuestLogin" @send-message="onSendMessage" @send-events="onEvents" @selectMenu="onMenuSelect"
        v-if="!is_loading && dockMenuValue == 'chat'" :isMobile="isMobile" :selectedTheme="selectedTheme" :api="api"
        ref="mainContentRef" />
      <Follows v-if="dockMenuValue === 'following'" :follows="followList" @selectMenu="onMenuSelect" />
      <Reels v-if="dockMenuValue === 'reels'" :reels="reelList" @selectMenu="onMenuSelect"
        :boughtContents="boughtContents" :popular_users="popular_users" />
      <Matches v-if="dockMenuValue === 'matches'" @selectMenu="onMenuSelect" />
      <ManageReels v-if="dockMenuValue === 'manage_reels'" />
      <SettingsDialog :my_profile="my_profile" :settings="getSettings" :blocks="blockedUsers"
        v-if="dockMenuValue === 'settings' && !is_loading" @update-profile="updateProfile" @send-events="onEvents" :g_settings="g_settings" :securityDetails="securityDetails"/>
    </div>

    <MobileConversations v-if="!is_loading && dockMenuValue === 'mobile_conversations' && isMobile"
      :conversations="conversations" :selected="selected" :selected_id="selected_id" @update-selected="updateSelected"
      @send-events="onEvents" :popular_users="popular_users" :my_profile="my_profile" />




    <Profile :my_profile="my_profile" ref="dialogRefForProfile" @update-profile="updateProfile" />

    <SubscriptionDialog :my_profile="my_profile" ref="SubscriptionDialogRef" :products="products" />
    <ChannelManage ref="dialogRefChannel" />
    <ChannelPasswordRequied ref="dialogRefChannelPassword" />
    <Toast position="top-left" group="tl" />
    <Toast position="bottom-left" group="bl" />
    <Toast position="bottom-right" group="br" />
    <Toast position="center" group="bc">
      <template #message="slotProps">
        <div class="flex flex-col items-start flex-auto">
          <div class="font-medium text-lg my-4">{{ slotProps.message.summary }}</div>
          <Button size="small" label="Continue with this screen" severity="success" @click="reconnect()"></Button>
        </div>
      </template>
    </Toast>
    <Calling ref="dialogCallRef" @startSession="startLiveKitSession" :conversations="conversations"
      @endSession="endLiveKitSession" />
    <Login :login_complated="login_complated" @login-completed="loginCompleted" />

    <Gift ref="dialogGiftRef" :gifts="giftList" />

    <Notifications ref="dialogNotificationsRef" :notifications="notifications"
      @notificationAction="onNotificationAction" />
    <LoadCredit ref="dialogCreditRef" :products="products" :my_profile="my_profile"
      :dialogCreditMessage="dialogCreditMessage" />
    <LookProfile ref="rightBarProfileRef" @selectMenu="onMenuSelect" />
    <Support ref="supportDialogRef" />

    <Dialog v-model:visible="visibleReconnect" modal header="Disconnected..." :style="{ width: '25rem' }"
      :closeOnEscape="false" :closable="false">
      <div class="flex items-center gap-2 mb-4">
        <i class="pi pi-exclamation-triangle text-3xl text-red-500"></i>
        <span class="font-bold text-lg">Reconnecting...</span>
      </div>
    </Dialog>
    <PopularAddMe ref="addMeDialogRef" :popular_users="popular_users" :my_id="my_profile.user_id"
      :g_settings="g_settings" />
    <CreateChannelDialog ref="createChannelDialogRef" :g_settings="g_settings" />
    <ChannelList ref="ChannelListDialogRef" @send-events="onEvents" />

    <GuestRegister ref="guestRegisterRef" />
    <BanTableDialog ref="klineBanDialog" />

    <ConfirmDialog></ConfirmDialog>

    <PaymentSuccess ref="dialogAfterPayment" />


    
    <KlineDialog ref="klineDialogRef" />
    <audio ref="notificationSound" src="https://cdn1.easychatrooms.com/assets/new_message.mp3"></audio>
  </main>
</template>

<script>
import axios from 'axios';

import MainContent from './components/MainContent.vue';
import Follows from './components/Follows.vue';
import Reels from './components/Reels.vue';
import Matches from './components/Matches.vue';
import ManageReels from './components/ManageReels.vue';



import Gift from './components/dialogs/Gift.vue';

import DockMenu from './components/DockMenu.vue';
import ToolBar from './components/ToolBar.vue';
import LeftBarArea from './components/LeftBarArea.vue';
import Profile from './components/settings/Profile.vue';
import SettingsDialog from './components/settings/SettingsDialog.vue';
import ChannelManage from './components/settings/ChannelManage.vue';
import ChannelPasswordRequied from './components/settings/ChannelPasswordRequied.vue';
import PopularAddMe from './components/dialogs/PopularAddMe.vue';
import SubscriptionDialog from './components/dialogs/SubscriptionDialog.vue';
import Calling from './components/dialogs/Calling.vue';
import Login from './components/dialogs/Login.vue';
import Notifications from './components/dialogs/Notifications.vue';
import LoadCredit from './components/dialogs/LoadCredit.vue';
import LookProfile from './components/dialogs/LookProfile.vue';
import CreateChannelDialog from './components/dialogs/CreateChannelDialog.vue';
import ChannelList from './components/dialogs/ChannelList.vue';
import KlineDialog from './components/dialogs/KlineDialog.vue';
import GuestRegister from './components/dialogs/GuestRegister.vue';
import BanTableDialog from './components/dialogs/BanTableDialog.vue';
import PaymentSuccess from './components/dialogs/PaymentSuccess.vue';


import setupSocketListeners from './socket-events';
import MobileConversations from './components/MobileConversations.vue';
import Support from './components/dialogs/Support.vue';
import { setLocale } from './i18n';

import FingerprintJS from '@fingerprintjs/fingerprintjs'

export default {
  name: 'App',
  components: {
    DockMenu,
    ToolBar,
    Follows,
    Reels,
    Matches,
    ManageReels,
    MainContent,
    LeftBarArea,
    Profile,
    SettingsDialog,
    ChannelManage,
    ChannelPasswordRequied,
    SubscriptionDialog,
    CreateChannelDialog,
    KlineDialog,
    BanTableDialog,
    GuestRegister,
    Calling,
    Login,
    Gift,
    LoadCredit,
    Notifications,
    MobileConversations,
    LookProfile,
    Support,
    PopularAddMe,
    ChannelList,
    PaymentSuccess
  },
  data() {
    return {
      isGuestLogin: false,
      selectedTheme: window.easychatrooms.theme || 'light',
      dockMenuValue: 'chat',
      isMobile: false,
      show_users: true,
      visibleReconnect: false,
      login_complated: null,
      is_loading: true,
      last_channel_data: null,
      my_fingerprint: null,
      popular_users: [],
      followList: [],
      reelList: [],
      giftList: [],
      liveList: [],
      blockedUsers: [],
      notifications: [],
      boughtContents: [],
      GlobalAdminLevels: [],
      dialogCreditMessage: '',
      basicMode: false,
      g_settings: {
        popular: 10,
        popular_time: 48,
        create_channel: 0,
        channel_autojoin: 100,
        maximum_channels: 0,
        maximum_conversations: 0,
      },
      api: {
        LiveKitUrl: '',
        reCAPTCHA: '',
      },
      products: [],
      my_profile: {
        nickname: '',
        access: -1,
        about: '',
        gender: '',
        age: '',
        golds: 0,
        location: '',
        hobbies: [],
        passions: [],
        height: '',
        relationshipGoals: '',
        languages: [],
        jobTitle: '',
        education: '',
        profile_images: [],
      },
      isDialogVisible: true,
      admin_levels: null,
      settings: {
        clearMessages: false,
        showSpam: false,
        showNSFW: false,
        showBlockedUsersMessage: false,
        timestamp: true,
        typing: true,
        reactions: true,
        notifications: false,
        sound: true,
        email: false,
        push: false,

      },
      selected: 0,
      selected_id: 0,
      bg_image: null,
      conversations: [
        {
          id: 0,
          name: 'Status',
          is_audio: false,
          levels: [],
          users: [],
          typing: [],
          topic: 'System messages',
          private: false
        }
      ],
      chatTokenForSystem: null,
      defaultSelectedUser: 0,
      is_killed: false,
      securityDetails: null,
    };
  },
  beforeMount: function () {
    this.handleResize();
  },
  computed: {
    getSettings() {
      const records = [];
      for (const key in this.settings) {
        if (this.settings[key])
          records.push(key);
      }
      return records;
    }
  },

  watch: {
    'selectedTheme': function (val, oldVal) {
      console.log('theme changed', val, oldVal);
      const root = document.getElementsByTagName('html')[0];
      if (val == 'dark') {
        root.classList.add('p-dark');
      } else {
        root.classList.remove('p-dark');
      }
    }
  },

  mounted: async function () {



    // Initialize the agent at application startup.
    const fpPromise = FingerprintJS.load();
    const fp = await fpPromise
    const result = await fp.get()
    console.log(result);
    this.my_fingerprint = result.visitorId

    const self = this;
    if (this.selectedTheme == 'dark') {
      document.getElementsByTagName('html')[0].classList.add('p-dark');
    }

    window.addEventListener('message', async function (event) {

      const data = event.data;
      if (data.type !== 'easychat-listener') {
        return;
      }



      if (data.action == 'language-changed') {
        console.log(self.$i18n);
        await setLocale(self.$i18n, data.value);
        localStorage.setItem('preferredLanguage', data.value);
      }

      if (data.action == 'theme-changed') {
        if (data.value == 'dark') {
          self.selectedTheme = 'dark';
        } else {
          self.selectedTheme = 'light';
        }
      }

    });

    this.handleMessage = (event) => {


      const { type, token } = event.data;

      if (type === 'disconnect') {

        const conversation = this.conversations.find(conversation => (conversation.liveKit && conversation.liveKit.token == token));
        if (conversation) {
          conversation.liveKit = null;
          this.$socket.emit('call-ended', { to: conversation.user_id });
        }

      }
    };

    window.addEventListener('message', this.handleMessage);


    window.addEventListener('resize', this.handleResize);
    setupSocketListeners(this.$socket, this);

   
    const url = new URL(window.location.href);
    const basicMode = url.searchParams.get('basicMode');
    if (basicMode && basicMode == 'true' || window.easychatrooms.basicMode && window.easychatrooms.basicMode == 'true') {
      this.basicMode = true;
    }
    
    if (window.self !== window.top) {
      const token = url.searchParams.get('token');

      if (token) {
        this.chatTokenForSystem = token;
      }
      if (url.searchParams.get('defaultSelectedUser')) {
        this.defaultSelectedUser = url.searchParams.get('defaultSelectedUser');
      }
    }


    if (this.chatTokenForSystem) {
      this.login_complated = true;
      this.$socket.io.opts.query = {
        tokenForSystem: this.chatTokenForSystem
      }
      this.$socket.connect();
    } else {

      if (window.easychatrooms) {
        if (window.easychatrooms.user_id && window.easychatrooms.password) {
          const result = await axios.post(this.$socket_url + '/login', { user_id: window.easychatrooms.user_id, password: window.easychatrooms.password });
          if (result.data.status) {
            this.login_complated = true;
            this.$socket.io.opts.query = {
              userId: window.easychatrooms.user_id,
              password: window.easychatrooms.password,
              my_fingerprint: this.my_fingerprint
            }
            this.$socket.connect();
          } else {
            this.login_complated = false;
            this.login_result_message = result.data.message ? result.data.message : 'Login failed';
          }
        } else {
          this.login_complated = false;
        }
      }
    }
    this.is_loading = false;
  },
  unmounted() {
    this.$socket.removeAllListeners();

  },
  methods: {

    loadApiSettings(data) {
      this.api.LiveKitUrl = data.livekit;
    },

    reConnect() {
      if (this.is_killed)
        return;
      this.visibleReconnect = true;
      setTimeout(() => {
        this.$socket.connect();
      }, 2000);
    },
    onConnected() {
      this.is_loading = false;
      this.login_complated = true;
      this.visibleReconnect = false;
    },

    updateAudioChatToken(data) {
      const conversation = this.conversations.find(conversation => conversation.id == data.channel_id);
      if (conversation) {
        conversation.liveKit = {
          token: data.jwt,
          isVideo: false,
          access: data.access
        };
      }
    },


    showKlineList(data) {
      if (!data || !data.length) {
        this.$toast.add({ severity: 'info', summary: 'Info', detail: 'There is no data to show in k-line list', life: 10000, group: 'br' });
        return;
      }
      this.$refs.klineBanDialog.showTableDialog(data);
    },
    showKlinePopup(data) {
      this.is_killed = true;
      this.$refs.klineDialogRef.showDialog(data);
    },

    loadChannelList(data) {

      const currentChannels = this.conversations
        .filter(conversation => !conversation.private)
        .map(conversation => conversation.id);
      this.$refs.ChannelListDialogRef.showTable(data, currentChannels);

    },
    onEvents(data) {
      if (data.action == 'open-profile') {
        this.$refs.dialogRefForProfile.openDialog();
      } else if (data.action == 'close-private') {
        this.closePrivateConversation(data.id);
      } else if (data.action == 'remove-private') {
        this.closePrivateConversation(data.id);
        this.$socket.emit('remove-private-conversation', data.id);
      } else if (data.action == 'open-users') {
        this.show_users = !this.show_users;
      } else if (data.action == 'open-diamond-dialog') {
        if (this.my_profile.is_premium) {
          return this.createManageSubscription();
        }
        this.$refs.SubscriptionDialogRef.openDialog();
      } else if (data.action == 'set-dock-menu') {
        this.dockMenuValue = data.value;
      } else if (data.action == 'video-call') {
        this.$refs.dialogCallRef.startCall(this.conversations[this.selected], true);
      } else if (data.action == 'audio-call') {
        this.$refs.dialogCallRef.startCall(this.conversations[this.selected], false);
      } else if (data.action == 'send-gift') {
        this.sendGift(data.user);
      } else if (data.action == 'open-notifications') {
        this.$refs.dialogNotificationsRef.toogleNotifications();
      } else if (data.action == 'open-credit-dialog') {
        this.$refs.dialogCreditRef.toggle();
      } else if (data.action == 'unblock') {
        this.$socket.emit('block', { action: 'delete', target: data.user_id });
      } else if (data.action == 'open-user-profile') {
        this.$refs.rightBarProfileRef.showProfile(data.user);
      } else if (data.action == 'open-support') {
        this.$refs.supportDialogRef.showDialog();
      } else if (data.action == 'settings') {
        this.updateSettings(data.settings);
      } else if (data.action == 'add-to-favorite') {
        this.$refs.addMeDialogRef.show();
      } else if (data.action == 'create-channel-disabled') {
        this.$toast.add({ severity: 'error', summary: this.$t('error_messages.error'), detail: this.$t('error_messages.create_channel_disabled'), life: 4000 });
      } else if (data.action == 'create-channel-dialog') {
        this.$refs.createChannelDialogRef.showDialog();
      } else if (data.action == 'confirmAdultChannel') {
        this.confirmAdultChannel(data.channel);
      } else if (data.action == 'guest-complete') {
        this.$refs.guestRegisterRef.showDialog();
      } else if (data.action == 'close-channel') {
        this.$socket.emit('part', { id: data.id });
      } else if (data.action == 'open-settings') {
        this.dockMenuValue = 'settings';
      }

    },

    setOnline(user_id) {
      for (let index = 0; index < this.conversations.length; index++) {
        if (this.conversations[index].private == true && this.conversations[index].user_id == user_id) {
          this.conversations[index].online = true;
        }
      }
      const followUser = this.followList.find(user => user.id == user_id);
      if (followUser) {
        followUser.online = 1;
      }
    },

    channelWaitingList(data) {
      const channel = this.conversations.find(conversation => conversation.id == data.channel_id);
      if (channel) {
        channel.waiting = data.waiting;
      }
    },
    async createManageSubscription() {
      try {
        const response = await axios.get(this.$socket_url + '/stripe/createLinkForManageSubscription/', {
          headers: {
            'Authorization': this.$socket.authKeyUnique.auth,
          }
        });

        if (response.data.url) {
          window.open(response.data.url, '_blank').focus();
        }
        console.log(response.data)
      } catch (error) {
        console.log(error);
      }
    },
    setOffline(user_id) {
      for (let index = 0; index < this.conversations.length; index++) {
        if (this.conversations[index].private == true && this.conversations[index].user_id == user_id) {
          this.conversations[index].online = false;
        }
      }
      const followUser = this.followList.find(user => user.id == user_id);
      if (followUser) {
        followUser.online = 0;
      }
    },

    updateSettings(newSettings) {
      for (const key in this.settings) {
        if (newSettings.find(item => item == key)) {
          this.settings[key] = true;
        } else {
          this.settings[key] = false;
        }
      }
      this.$socket.emit('settings', this.settings);
    },

    loadSettings(data) {
      if (!data)
        return
      try {
        const settings = JSON.parse(data);
        for (const key in this.settings) {
          if (settings[key] && settings[key] == true) {
            this.settings[key] = true;
          } else {
            this.settings[key] = false;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },

    afterPaymentProcess(data) {
      this.my_profile.golds = data.golds;
      this.my_profile.is_premium = data.is_premium;
      this.$refs.dialogAfterPayment.showDialog();




    },

    goldNotEnough(data) {
      let mesage = '';
      switch (data.action) {
        case 'buy':
          mesage = this.$t('load_credit_dialog.buy_reels', { amount: data.price });
          break;
        case 'gift':
          mesage = this.$t('load_credit_dialog.gift', { amount: data.price });
          break;
        case 'popular':
          mesage = this.$t('load_credit_dialog.popular', { amount: data.price });
          break;
        case 'create_channel':
          mesage = this.$t('load_credit_dialog.create_channel', { amount: data.price });
          break;
        default:
          break;


      }
      this.dialogCreditMessage = mesage;
      this.$refs.dialogCreditRef.show();

    },

    closePrivateConversation(id) {
      var findIndex = -1;
      if (id < 0) {
        findIndex = this.conversations.findIndex(conversation => conversation.user_id === (id * -1));
      } else {
        findIndex = this.conversations.findIndex(conversation => conversation.id === id);
      }
      if (findIndex != -1) {
        this.conversations.splice(findIndex, 1);
        this.updateSelected(this.conversations[this.conversations.length - 1].id);
      }
    },
    updateSelected(newSelected) {

      if (this.isMobile) {
        this.dockMenuValue = 'chat';
      }
      var findIndex = -1;
      if (newSelected < 0) {
        findIndex = this.conversations.findIndex(conversation => conversation.user_id === (newSelected * -1));
      } else {
        findIndex = this.conversations.findIndex(conversation => conversation.id === newSelected);
      }

      if (findIndex != -1) {
        if (this.conversations[findIndex].private && typeof this.conversations[findIndex].get_messages !== 'undefined' && this.conversations[findIndex].get_messages === false) {
          this.$socket.emit('getPrivMsg', { conversation_id: this.conversations[findIndex].id, _id: this.conversations[findIndex]._id });
          this.conversations[findIndex].get_messages = true;
        }

        if (this.isMobile) {
          this.show_users = false;
        } else {
          this.show_users = true;
        }



        this.selected_id = this.conversations[findIndex].id;
        this.selected = findIndex;
        if (this.conversations[findIndex].bg_image) {
          this.bg_image = this.conversations[findIndex].bg_image;
        } else {
          this.bg_image = null;
        }
        if (this.conversations[findIndex].private && Object.keys(this.conversations[findIndex].profile).length === 0) {
          this.$socket.emit('getProfile', this.conversations[findIndex].user_id);
        }
        this.conversations[findIndex].unread = 0;
        setTimeout(() => {
          const element = document.getElementById('m1_Easy');
          if (element) {
            element.scrollTop = element.scrollHeight;
          }
        }, 100);


      }


    },
    onTyping(data) {
      data.conversation_id = this.conversations[this.selected].id;
      this.$socket.emit('typing', data);
    },
    onSendMessage(messageData) {
      if (this.conversations[this.selected].private === false) {
        messageData.channel_id = this.conversations[this.selected].id;
        this.$socket.emit('message', messageData);
      } else {
        messageData.user_id = this.conversations[this.selected].user_id;
        this.$socket.emit('message', messageData);
      }

    },
    onMenuSelect(data) {
      switch (data.action) {
        case "message": {

          const countPrivate = this.conversations.filter(conversation => conversation.private === true).length;

          if (this.my_profile.gender == 1 && this.my_profile.is_premium == false && this.g_settings.maximum_conversations && countPrivate >= this.g_settings.maximum_conversations) {
            this.showToast({ severity: 'error', summary: this.$t('error_messages.info'), detail: this.$t('error_messages.maximum_conversations') });
            this.$refs.SubscriptionDialogRef.openDialog();
            return;
          }


          const cons_id = this.createConversationId(this.my_profile.user_id, data.user.user_id);
          const findIndex = this.conversations.findIndex(conversation => conversation.id === cons_id);
          if (findIndex != -1) {
            this.updateSelected(cons_id);
          } else {
            this.conversations.push({
              id: cons_id,
              user_id: data.user.user_id,
              name: data.user.nickname,
              avatar: data.user.avatar,
              is_audio: false,
              levels: [],
              users: [],
              typing: [],
              messages: [],
              topic: '',
              private: true,
              unread: 0,
              get_messages: false,
              profile: {},
              online: data.user.online ? 1 : 0
            });
            this.updateSelected(cons_id);
            this.$socket.emit('isOnline', data.user.user_id);
          }
          this.dockMenuValue = 'chat';
          break;
        }
        case "showProfile": {
          this.$refs.rightBarProfileRef.showProfile(data.user);
          break;
        }
        case "addFollow": {
          this.$socket.emit('follow', { action: 'add', target: data.user.user_id });
          break;
        }
        case "removeFollow": {
          this.$socket.emit('follow', { action: 'delete', target: data.user.user_id });
          break;
        }
        case "gift": {
          this.sendGift(data.user);
          break;
        }
        case "block": {
          this.$socket.emit('block', { action: 'add', target: data.user.user_id });
          break;
        }
        case "unblock": {
          this.$socket.emit('block', { action: 'delete', target: data.user.user_id });
          break;
        }
        case "open-manage-reels": {
          this.dockMenuValue = 'manage_reels';
          break;
        }
        default:
          break;
      }
    },
    createConversationId(senderId, receiverId) {
      const id = [senderId, receiverId].sort().join('_');
      return id;
    },
    updateProfile(profile) {
      this.my_profile = profile;
      this.$socket.emit('updateProfile', profile);
    },
    showToast(data) {
      this.$toast.add({ severity: data.severity, summary: data.summary, detail: data.detail, life: (data.life ? data.life : 10000), group: 'br' });
    },

    openChannelDetails(data) {
      this.$refs.dialogRefChannel.channel = data;
      this.$refs.dialogRefChannel.openDialog();
    },
    showPasswordFormForChannel(data) {
      this.$refs.dialogRefChannelPassword.channel = data;
      this.$refs.dialogRefChannelPassword.openDialog();
    },
    updateAvatar(avatar) {
      this.my_profile = { ...this.my_profile, avatar: avatar };
    },
    checkIsMobile() {
      return window.innerWidth < 768;
    },
    handleResize() {
      this.isMobile = this.checkIsMobile();
    },
    showDumplicated() {
      this.$toast.add({ severity: 'success', summary: 'Chat page is open in another window. Click "Use here" to continue chat in this window.', group: 'bc' });
    },
    sendGift(user) {
      this.$refs.dialogGiftRef.setTarget(user);
    },
    reconnect() {
      if (this.$socket && !this.$socket.connected) {
        this.$socket.connect();
      }
    },
    deleteMessage(data) {
      if (data.conversation) {
        const conversation = this.conversations.find(conversation => conversation.id === data.conversation);
        if (conversation) {
          conversation.messages = conversation.messages.filter(message => message.id != data.message_id);
        } else {
          console.log('Conversation not found');
        }

      }
    },
    loginCompleted(data) {
      this.$socket.io.opts.query = {
        my_fingerprint: this.my_fingerprint,
        userId: data.user_id,
        password: data.password
      }
      this.$socket.connect();
      if (data.isGuest) {
        this.isGuestLogin = true;
      }

      this.login_complated = true;
    },
    onNotificationAction(data) {
      if (data.action == 'read') {
        if (data.id == 'all') {
          this.notifications = this.notifications.map(notification => {
            notification.unread = false;
            return notification;
          });
        } else {
          this.notifications = this.notifications.map(notification => {
            if (notification.id == data.id) {
              notification.unread = false;
            }
            return notification;
          });
        }
      } else if (data.action == 'delete') {
        if (data.id == 'all') {
          this.notifications = [];
        } else {
          this.notifications = this.notifications.filter(notification => notification.id != data.id);
        }
      }
    },
    startLiveKitSession(data, isVideo, targetUser) {

      const conversation = this.conversations.find(conversation => conversation.user_id == targetUser);
      if (conversation) {
        conversation.liveKit = {
          token: data.jwt,
          isVideo
        };
      }
    },

    endLiveKitSession(user_id) {
      const conversation = this.conversations.find(conversation => conversation.user_id == user_id);
      if (conversation) {
        conversation.liveKit = null;
      }
    },

    updateTheme(newValue) {
      console.log('new theme value', newValue);
      this.selectedTheme = newValue;
    },
    updateBlockedUsers(newValue) {
      if (newValue.length > 0) {
        this.blockedUsers = [];
        newValue.forEach(user => {
          this.blockedUsers.push(user);
        })
      } else {
        this.blockedUsers = [];
      }
    },
    setUnreadMessages(index) {


      if (this.conversations[index].private) {
        const unreadSenderIds = this.conversations[index].messages
          .filter(message => message.unread === 1 && message.senderId !== this.my_profile.user_id)
          .map(message => message.id);

        this.conversations[index].messages.forEach(message => {
          if (message.unread === 1 && message.senderId === 2) {
            message.unread = 0;
          }
        });

        this.$socket.emit('setUnread', unreadSenderIds);
      }
    },
    pushPrivateMessage(data) {

      const channel = this.conversations.find(conversation => conversation.id === data.conversationId);
      const channel_index = this.conversations.findIndex(conversation => conversation.id === data.conversationId);

      if (channel) {
        channel.messages.push(data);
        if (this.selected != channel_index && this.my_profile.user_id !== data.senderId) {
          channel.unread++;
          if (this.settings.sound) {
            this.$refs.notificationSound.play();
          }
        }
      } else {
        if (this.my_profile.user_id == data.senderId) {
          return;
        }
        this.conversations.push({
          id: data.conversationId,
          user_id: data.senderId,
          name: data.senderNickname,
          avatar: data.senderAvatar,
          is_audio: false,
          levels: [],
          users: [],
          messages: [],
          typing: [],
          topic: '',
          private: true,
          unread: 1,
          get_messages: false,
          profile: {},
          online: 1
        });
      }
    },
    pushChannelMessage(data) {
      const channel = this.conversations.find(c => c.id === data.channel_id);
      const channelIndex = this.conversations.findIndex(c => c.id === data.channel_id);
      if (channel) {
        channel.messages.push(data);
      }
      if (this.selected !== channelIndex) {
        channel.unread = 1;
      }
    },
    updatePopulerUsers(users) {
      this.popular_users = users;
    },
    loadGlobalSettings(data) {
      if (!data)
        return;
      for (const key in data) {
        if (Object.prototype.hasOwnProperty.call(this.g_settings, key)) {
          this.g_settings[key] = data[key];
        } else {
          this.g_settings[key] = data[key];
        }
      }
    },
    loadProducts(data) {
      this.products = data;
    },
    showPopularCompleted(date) {
      alert(date);
    },
    confirmAdultChannel(channel) {
      this.$confirm.require({
        message: this.$t('channelList.adult_content_confirm'),
        header: this.$t('channelList.confirmation'),
        icon: 'pi pi-exclamation-triangle',
        rejectProps: {
          label: 'Cancel',
          severity: 'secondary',
          outlined: true
        },
        acceptProps: {
          label: this.$t('channelList.i_am_18'),
        },
        accept: () => {
          this.$socket.emit('join', {
            id: channel.id,
            name: channel.name,
          });
        },
        reject: () => {
        }
      });
    },
    processError(data) {

      console.log(data);
      if (data.code == 'incorrect_password') {
        this.showPasswordFormForChannel(data);
      }

      if (data.code == 'exceed_max_channels') {
        this.$refs.SubscriptionDialogRef.openDialog();
      }

      if (data.code.indexOf('guest_members_can') != -1) {
        this.$refs.mainContentRef.showGuestAlert();
      }

      if (data.code == 'withdraw_error') {
        return   this.showToast({ severity: 'error', summary: data.msg,  });
      }

      const extras = {};
      if (data.channel) {
        extras['channel'] = '#' + data.channel;
      }

      const messageKey = `error_messages.${data.code}.message`;
      this.showToast({ severity: 'error', summary: this.$t(messageKey, { ...extras }) });
      return true;
    },
    updateChannelUsersLevels(conversation_id) {
      const conversation = this.conversations.find(conversation => conversation.id === conversation_id);

      if (!conversation) {
        console.error(`Conversation with ID ${conversation_id} not found.`);
        return;
      }

      if (!Array.isArray(conversation.users) || conversation.users.length === 0) {
        console.warn(`No users found in conversation with ID ${conversation_id}.`);
        return;
      }

      const targetUsers = conversation.users.filter(user => user.access_global > 0);
      for (const user of targetUsers) {
        const targetLevel = this.GlobalAdminLevels.find(level => level.access === user.access_global);
        if (targetLevel) {
          user.crown = targetLevel.crown;
          user.extra = { title: targetLevel.title, color: targetLevel.color, crown: targetLevel.crown };
        }
      }

    },

    userJoinToChannel(data) {
      const channel = this.conversations.find(conversation => conversation.id === data.id);
      if (channel) {
        const userInChannel = channel.users.find(user => user.user_id === data.user.user_id);
        if (data.user.access_global > 0) {
          const targetLevel = this.GlobalAdminLevels.find(level => level.access === data.user.access_global);
          if (targetLevel) {
            data.user.extra = { title: targetLevel.title, color: targetLevel.color, crown: targetLevel.crown };
          }
        }
        if (!userInChannel) {
          channel.users.push(data.user);
        }
      }
    }



  },
  beforeUnmount() {
    if (this.$socket) {
      this.$socket.disconnect();
    }
    window.removeEventListener('message', this.handleMessage);
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style scoped>
.app-layout {
  font-family: "Noto Sans", sans-serif;
  font-size: 14px;
  color: var(--text-color);
}

.app-layout.loading {
  display: flex;
}

#main_content_easychat {
  position: relative;
}

#middle_Easy {
  height: calc(100% - 50px);
  width: calc(100% - 80px);
  float: left;
}

li.unread_channel {
  color: var(--p-red-400);
}

@media screen and (max-width: 768px) {
  #middle_Easy {
    width: 100%;
    height: calc(100% - 50px);
  }
}
</style>
